var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowValueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4298 19H7.5403L7.54037 18.9887C7.13209 18.9879 6.74078 18.832 6.45197 18.5551C6.16335 18.278 6.00062 17.9025 6 17.5108L6.02961 12.1339C6.03023 11.801 6.14783 11.478 6.36315 11.2172C6.57844 10.9561 6.87927 10.7726 7.21675 10.6957V9.568C7.21569 8.3316 7.74094 7.14842 8.67118 6.29285C9.56559 5.4601 10.7639 4.99605 12.0103 5.00003H12.1172C13.3648 5.05505 14.542 5.56995 15.4035 6.43748C16.1457 7.18484 16.4056 8.22019 16.4616 9.25879H13.9944C13.925 8.86089 13.7564 8.46625 13.4815 8.19344C13.0898 7.80469 12.5503 7.58518 11.9865 7.58558C11.4774 7.58496 10.9863 7.76673 10.6093 8.09529C10.1685 8.47274 9.91588 9.0125 9.91485 9.5792L9.90907 10.6698L16.7416 10.6957C17.0946 10.7593 17.4137 10.9393 17.6435 11.2045C17.8731 11.4695 17.9994 11.8032 18 12.1481L17.9704 17.5219C17.9696 17.9136 17.807 18.2892 17.5182 18.5662C17.2296 18.8433 16.8381 18.9992 16.4298 19Z",
    fill: "#C2C4CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowValueIcon);
export default __webpack_public_path__ + "static/media/show-value-icon.00586121feac13815c623c6740186af9.svg";
export { ForwardRef as ReactComponent };